import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import DashboardLayout from '../layouts/dashboard';
export const IndexPage = lazy(() => import('../pages/app'));
export const ExamPage = lazy(() => import('../pages/exams'));
export const SubmittedExamPage = lazy(() => import('../pages/submitted-exams'));
export const StudentResultPage = lazy(() => import('../pages/student-result'));
export const StartExamPage = lazy(() => import('../pages/start-exam'));
export const ExamPanelPage = lazy(() => import('../pages/exam-panel'));
export const Page404 = lazy(() => import('../pages/page-not-found'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { element: <IndexPage />, index: true },
        { path: 'exam', element: <ExamPage /> },
        { path: 'submitted-exams', element: <SubmittedExamPage /> },
        { path: 'exam-result', element: <StudentResultPage /> },
        { path: 'start-exam', element: <StartExamPage /> },
        //{ path: 'add-exam', element: <AddExamPage /> },
        //{ path: 'edit-exam/:id', element: <EditExamPage/> },
        //{ path: 'question/:e_id', element: <QuestionPage /> },
        //{ path: 'add-question', element: <AddQuestionPage /> },
        //{ path: 'add-student', element: <AddStudentPage /> },
        //{ path: 'student', element: <Students/> },
        //{ path: 'edit-student/:student_id', element: <EditStudentPage/> },
        //{ path: 'edit-question/:exam_id/:question_id', element: <EditQuestionPage/> },
        
      ],
    },
    // {
    //   path: 'login',  
    //   element: <LoginPage />,
    // },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: 'exam-panel',
      element: <ExamPanelPage />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
